<template>
    <div class="notice_bar">
        <router-link to="/notice"  class="title" :class="$route.name=='Recycle'?'orange':'blue'"> 
            <img :src="$route.name=='Recycle'?'https://image.shoukala.com/image/shoukala_new/laba.png':'https://image.shoukala.com/image/shoukala_new/laba_blue.png'" alt="" style="margin-bottom:2px;"> 公告 | More>
        </router-link>
        <ul>
            <li v-for="(item,index) in noticeList" :key="index" :class="$route.name=='Recycle'?'orange':'gray'">
                <router-link :to="{path:'/notice', query:{newsIndex: index}}">{{item.addTime}}   {{item.title}}</router-link>
            </li>
        </ul>
	</div>
</template>

<script>
import {announceInfo} from'@/api/message'
export default {
    data(){
        return{
            noticeList:[]
        }
    },
    created(){
        const submitData = {
            'curr_page': 1,
            'page_size': 3,
            'type_code': 0
        }
        announceInfo(submitData).then(res => {
            if(res.data.code == '100001'){
                this.noticeList = res.data.result.order_list;
            }
        })
    }
}
</script>

<style scoped lang="scss">
.notice_bar{
    width:1200px;
    height: 46px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 46px;
    .title{
        font-weight: bold;
        cursor: pointer;
        vertical-align: top;
    }
    .orange{
        color: #FF8A00;
    }
    .blue{
        color: #0095F5;
    }
    ul{
        display: inline-block;
        li{
            display: inline-block;
            width: 300px;
            margin-left: 50px;
            vertical-align: top;
            cursor: pointer;
            span{
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                display: inline-block;
                text-overflow: ellipsis;
            }
        }
        .orange{
            span{
                color: #FF8A00;
            }
        }
        .gray{
            span{
                color: #999999;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/announceBar.vue